import { Chip } from '@mui/material';
import { REQUEST_STATUS } from '../types';

type ChipColor = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'error';

export const getStatusLabel = (status: number): string => {
  switch (status) {
    case REQUEST_STATUS.NEW:
      return 'New';
    case REQUEST_STATUS.AWAITING_MENTOR_APPROVAL:
      return 'Awaiting Review';
    case REQUEST_STATUS.MENTOR_RESPONSE:
      return 'Needs Revision';
    case REQUEST_STATUS.OPEN:
      return 'Open';
    case REQUEST_STATUS.AWAITING_RESPONSE:
      return 'Awaiting Response';
    case REQUEST_STATUS.CLIENT_RESPONSE:
      return 'Client Response';
    case REQUEST_STATUS.AWAITING_THIRD_PARTY:
      return 'Waiting';
    case REQUEST_STATUS.AWAITING_MANAGER_RESPONSE:
      return 'Awaiting Manager';
    case REQUEST_STATUS.THIRD_PARTY_RESPONSE:
      return 'Third Party Response';
    case REQUEST_STATUS.CLOSED:
      return 'Closed';
    case REQUEST_STATUS.EXPIRED:
      return 'Expired';
    case REQUEST_STATUS.ARCHIVED:
      return 'Archived';
    default:
      return 'Unknown';
  }
};

export const getStatusColor = (status: number): ChipColor => {
  switch (status) {
    case REQUEST_STATUS.NEW:
      return 'primary';
    case REQUEST_STATUS.AWAITING_MENTOR_APPROVAL:
      return 'warning';
    case REQUEST_STATUS.MENTOR_RESPONSE:
      return 'error';
    case REQUEST_STATUS.OPEN:
      return 'info';
    case REQUEST_STATUS.CLIENT_RESPONSE:
      return 'warning';
    case REQUEST_STATUS.AWAITING_THIRD_PARTY:
      return 'secondary';
    case REQUEST_STATUS.CLOSED:
      return 'success';
    case REQUEST_STATUS.EXPIRED:
      return 'error';
    case REQUEST_STATUS.ARCHIVED:
      return 'default';
    default:
      return 'default';
  }
};

interface StatusChipProps {
  status: number;
  size?: 'small' | 'medium';
  variant?: 'detailed' | 'simple';
}

export function StatusChip({ status, size = 'small', variant = 'detailed' }: StatusChipProps) {
  if (variant === 'simple') {
    const isOpen = status < REQUEST_STATUS.CLOSED;
    return (
      <Chip
        label={isOpen ? 'Open' : 'Closed'}
        color={isOpen ? 'primary' : 'success'}
        size={size}
      />
    );
  }

  return (
    <Chip
      label={getStatusLabel(status)}
      color={getStatusColor(status)}
      size={size}
    />
  );
}
